import React from 'react';
import PropTypes from 'prop-types';

import theme from './AuthorizationForm.scss';

const propTypes = {
  form: PropTypes.node.isRequired,
  logo: PropTypes.node.isRequired,
};

const AuthorizationForm = ({ logo, form }) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <div className={ theme.logoContainer }>
        { logo }
      </div>
    </div>
    <div className={ theme.body }>
      { form }
    </div>
  </div>
);

AuthorizationForm.propTypes = propTypes;

export default AuthorizationForm;
